import { defineComponent } from 'vue';
import './index.less';
import { Plugin } from '@vue/runtime-dom';

export enum EN_AVATAR_TYPE {
  circle = 'circle',
  rect = 'rect',
}

const Davatar = defineComponent({
  components: {},
  props: {
    avatar: { type: String, required: false, default: '' },
    size: { type: [String, Number], required: true, default: 'small' },
    type: { type: String as PropType<EN_AVATAR_TYPE>, default: EN_AVATAR_TYPE.circle },
  },

  setup(props) {
    const renderImg = () => {
      if (!props.avatar) {
        return <div style={`background-color: gray; height: 100%`} />;
      }

      if (props.avatar[0] === '#') {
        return <div style={`background-color: ${props.avatar}; height: 100%`} />;
      } else {
        return (
          <img
            style={{ height: '100%' }}
            src={`${window.ENV_CONFIG['ossPrefix']}${props.avatar}`}
          ></img>
        );
      }
    };
    return {
      renderImg,
    };
  },
  render() {
    const { size } = this;
    return this.$props.type === EN_AVATAR_TYPE.circle ? (
      <a-avatar
        size={size}
        v-slots={{
          icon: () => {
            return this.renderImg();
          },
        }}
      />
    ) : (
      this.renderImg()
    );
  },
});

export const DAvatar: Plugin = {
  install: (app) => {
    // Plugin code goes here
    app.component('DAvatar', Davatar);
  },
};
